import { getConditionalArray } from 'utils/data';

const pluralizeAdded = count => (count === 1 ? '1 will be added' : `${count} will be added`);
const pluralizeSentBack = count =>
  count === 1 ? '1 sent back to the AI' : `${count} sent back to the AI`;
const pluralizeRemoved = count => (count === 1 ? '1 removed' : `${count} removed`);

export const buildAdjustSummary = ({ addCount, sentBackCount, removedCount }) =>
  [
    pluralizeAdded(addCount),
    ...getConditionalArray(sentBackCount > 0, () => [pluralizeSentBack(sentBackCount)]),
    ...getConditionalArray(removedCount > 0, () => [pluralizeRemoved(removedCount)]),
  ].join(' · ');

export const CONDITION_DECISION = {
  KEEP: 'Keep',
  EDIT: 'Edit',
  REMOVE: 'Remove',
  REJECT: 'Reject',
};

export const CONDITION_ROW_STATE = {
  KEEP: 'Keep',
  EDIT: 'Edit',
  REMOVE: 'Remove',
  REJECT: 'Reject',
};

export const EMPTY_CONDITION_TASKS = [];

export const EMPTY_BORROWER_OPTIONS = [];

export const CONDITION_REVIEW_VARIANT = {
  PROCESS: 'process',
  CHAT: 'chat',
};

export const CONDITION_REVIEW_LABELS = {
  INTERNAL_LABEL: 'Internal',
  BORROWER_LABEL: 'Borrower-facing',
  PRIOR_TO_LABEL: 'Prior to',
  EDIT: 'Edit',
  SEND_BACK: 'Send back to the AI',
  REMOVE: 'Remove',
  ADD_BACK: 'Add back',
  SEND_BACK_HEADER: 'Sending back — tell the AI what to fix',
  SEND_BACK_NOTE: 'The AI will revise this one and bring it back for review.',
  SEND_BACK_PLACEHOLDER: 'What should the AI fix on this condition?',
  SEND_BACK_CANCEL: 'Keep as is',
  EDIT_INTERNAL_LABEL: 'Internal',
  EDIT_BORROWER_LABEL: 'Borrower-facing',
  EDIT_PRIOR_TO_LABEL: 'Prior to',
  EDIT_SAVE: 'Save',
  EDIT_CANCEL: 'Cancel',
  EDIT_TASKS_LABEL: 'Task assignees',
  EDIT_TASK_ASSIGNEE_LABEL: 'Assignee',
  TASKS_LABEL: 'Tasks',
  TASK_FALLBACK: 'Task',
  TASK_ASSIGNEE: name => `for ${name}`,
  CONDITION_REFERENCE: ({ conditionId }) => `Condition #${conditionId}`,
};

export const ConditionReviewTestIds = {
  LIST: 'ConditionReview_List',
  ITEM: 'ConditionReview_Item',
  EDIT_BUTTON: 'ConditionReview_EditButton',
  SEND_BACK_BUTTON: 'ConditionReview_SendBackButton',
  REMOVE_BUTTON: 'ConditionReview_RemoveButton',
  ADD_BACK_BUTTON: 'ConditionReview_AddBackButton',
  EDIT_INTERNAL_INPUT: 'ConditionReview_EditInternalInput',
  EDIT_BORROWER_INPUT: 'ConditionReview_EditBorrowerInput',
  EDIT_PRIOR_TO_SELECT: 'ConditionReview_EditPriorToSelect',
  EDIT_SAVE: 'ConditionReview_EditSave',
  EDIT_CANCEL: 'ConditionReview_EditCancel',
  EDIT_TASKS: 'ConditionReview_EditTasks',
  EDIT_TASK_ASSIGNEE_SELECT: 'ConditionReview_EditTaskAssigneeSelect',
  SEND_BACK_INPUT: 'ConditionReview_SendBackInput',
  SEND_BACK_CANCEL: 'ConditionReview_SendBackCancel',
  TASKS: 'ConditionReview_Tasks',
  TASK_ITEM: 'ConditionReview_TaskItem',
  REFERENCE: 'ConditionReview_Reference',
};
